/* eslint-disable prettier/prettier */
import PromptTable from "./CopilotTable";
/* import Tool from "./Tools";
import Tags from "./Tags";
 */
const Copilot = () => {
  return <PromptTable />;
};

export default Copilot;